import {
  City,
  Date,
  PublicOfferContent,
  PublicOfferContentLink,
  PublicOfferContentLinkComponent,
  PublicOfferDate,
  PublicOfferInfo,
  PublicOfferInfoTitle,
  PublicOfferTitle,
  RequisitesTable,
  Wrapper,
} from "./style";

export const PublicOffer = () => {
  return (
    <Wrapper>
      <PublicOfferTitle>ДОГОВОР ПУБЛИЧНОЙ ОФЕРТЫ ОБ ОКАЗАНИИ УСЛУГ</PublicOfferTitle>

      <PublicOfferDate>
        <City>ООО «С-СЕРВИС»</City>
        <Date>Москва</Date>
      </PublicOfferDate>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>1. Общие положения</PublicOfferInfoTitle>

        <PublicOfferContent>
          1.1. В соответствии со ст.437 Гражданского кодекса Российской Федерации данный документ является официальным
          публичным предложением (офертой) Общества с ограниченной ответственностью «С-СЕРВИС» (далее по тексту –
          Агентство) заключить договор на указанных ниже условиях. Настоящая оферта содержит все существенные условия
          продажи и возврата электронных авиабилетов.
        </PublicOfferContent>

        <PublicOfferContent>
          1.2. Полным и безоговорочным акцептом настоящей публичной оферты (т.е. ответом о принятии оферты) является
          совершение физическим лицом действий по выполнению указанных в оферте условий договора, выражающих намерение
          воспользоваться сервисом для оформления электронного перевозочного документа.
        </PublicOfferContent>

        <PublicOfferContent>
          1.3. В случае принятия изложенных ниже условий физическое лицо, производящее акцепт данной оферты, выражает
          согласие со всеми положениями данной оферты и становится Заказчиком (акцепт оферты равносилен заключению
          договора на условиях, изложенных в оферте).
        </PublicOfferContent>

        <PublicOfferContent>
          1.4. Совершая действия по акцепту настоящей публичной оферты, Заказчик гарантирует достижение им возраста 18
          лет, а также подтверждает свою правоспособность и дееспособность.
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>2. Предмет оферты</PublicOfferInfoTitle>

        <PublicOfferContent>
          2.1. Агентство обязуется осуществлять на основании Заказа бронирование, продажу и оформление перевозок на
          электронных перевозочных документах в соответствии с условиями настоящей оферты, а Заказчик обязуется
          оплатить стоимость оформленных перевозок (провозную плату), а также дополнительную плату за оказание Агентом
          Заказчику услуг по подбору оптимального варианта перевозки, провозной платы за перевозку в соответствии с
          заданными пассажиром приоритетными параметрами условий перевозки.
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>3. Условия и порядок оплаты заказа. Возврат заказа</PublicOfferInfoTitle>

        <PublicOfferContent>
          3.1. Заказчик оплачивает услуги Перевозчика и Агентства путём 100% предоплаты. Оформленный заказ должен быть
          оплачен Заказчиком в течение времени, указанного при оформлении заказа (тайм-лимит), наличными средствами или
          банковской картой.
        </PublicOfferContent>

        <PublicOfferContent>
          3.2. Агентство оставляет за собой право взимать сервисные сборы за свои услуги по оформлению электронных
          авиабилетов. Сервисные сборы включены в стоимость Заказа. Размер сервисных сборов изменяется в зависимости от
          условий соглашений с авиакомпанией, выполняющей забронированный маршрут, правил применения тарифа на данную
          услугу, договором-офертой на авиаперевозку с авиакомпанией, действующим законодательством РФ.
        </PublicOfferContent>

        <PublicOfferContent>
          3.3. Цена Заказа формируется из цены фактической стоимости услуги, тарифа, налогов и сборов, указывается в
          Маршрутной квитанции пассажира (Электронном билете). Заказчик оплачивает услуги Перевозчика наличными или
          безналичным расчётом.
        </PublicOfferContent>

        <PublicOfferContent>
          3.4. Сервисные сборы Агентства не возвращаются Клиенту в случае возврата билета.
        </PublicOfferContent>

        <PublicOfferContent>
          3.5. Для возврата авиабилета пассажиру необходимо обратиться в контактный центр Агентства по телефону{" "}
          <a href="tel:+79856344104">+7 (985) 634-41-04</a>.
        </PublicOfferContent>

        <PublicOfferContent>
          3.6. За обмен и возврат билетов взимается дополнительный сервисный сбор.
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>4. Оформление заказа</PublicOfferInfoTitle>

        <PublicOfferContent>
          4.1. Процедура бронирования состоит из трех этапов. Первый этап заключается в подборе Клиентом оптимального
          варианта перелета, второй этап представляет собой предварительное бронирование мест. На третьем этапе Клиент
          подтверждает согласие с информацией, указанной в брони и вносит оплату за свой Заказ, после чего происходит
          оформление билета.
        </PublicOfferContent>

        <PublicOfferContent>
          4.2. Во избежание ошибок и неточностей при осуществлении бронирования авиабилетов, Агент настоятельно
          рекомендует Клиенту проверить информацию, внесенную при бронировании его авиабилета. В случае если Клиент не
          проверил информацию, претензии от Клиента по поводу ошибок в бронировании, убытков Клиента и т.п. не
          принимаются.
        </PublicOfferContent>

        <PublicOfferContent>
          4.3. Обязательства Агента считаются исполненными надлежащим образом и в полном объеме с момента отправки
          Клиенту маршрут-квитанции, содержащей условия, заключенного Клиентом договора перевозки.
        </PublicOfferContent>

        <PublicOfferContent>
          4.4. Никакое предварительное бронирование не является завершенным до момента оплаты и не гарантирует наличия
          мест по указанному тарифу и их стоимости и может быть аннулировано по требованию авиаперевозчика в любой
          момент.
        </PublicOfferContent>

        <PublicOfferContent>
          4.5. Фактом оформления заказа Клиент соглашается на все условия и ограничения, связанные с его бронированием.
        </PublicOfferContent>

        <PublicOfferContent>
          4.6. Если не указано иное, в большинстве случаев подтвержденное бронирование не может быть изменено, передано
          другому лицу или аннулировано. Изменения, передача и аннуляция возможны по правилам авиакомпаний с применением
          дополнительных сборов и штрафов. Если Клиент желает изменить или отменить свое бронирование, он должен
          немедленно связаться с Агентом по телефону{" "}
          <a href="tel:+79856344104">+7 (985) 634-41-04</a>.
        </PublicOfferContent>

        <PublicOfferContent>
          4.7. Клиент, бронирующий несколько авиабилетов или авиабилеты для сторонних лиц обязан донести все условия
          перевозки до всех пассажиров, участвующих в данном перелете.
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>5. Персональные данные</PublicOfferInfoTitle>

        <PublicOfferContent>
          5.1. В соответствии с частью 5 статьи 6 Федерального закона от 27 июля 2006 г. № 152-ФЗ «О персональных
          данных» обработка персональных данных Заказчика и/или пассажиров осуществляется в целях исполнения настоящей
          оферты и договора перевозки, одной из сторон которых является Заказчик и/или пассажир. Заказчик согласен
          (подтверждает наличие согласия всех пассажиров, внесённых в бронирование) на обработку персональных данных,
          введённых при бронировании (фамилия, имя, отчество, пол, дата рождения, гражданство, серия и номер паспорта
          или иные реквизиты документа удостоверяющего личность, номер телефона, адрес электронной почты) в том числе
          на их передачу третьим лицам, оказывающим содействие при бронировании, обеспечивающим или обслуживающим
          перевозку, и трансграничную передачу указанных персональных данных.
        </PublicOfferContent>

        <PublicOfferContent>
          5.2. Агентство обязуется обрабатывать вышеперечисленные персональные данные Заказчика и/или пассажиров,
          указанные Заказчиком при оформлении Заказа, исключительно в целях оформления продажи перевозок,
          идентификации Заказчика для осуществления перевозки и выполнения обязательств по настоящей публичной оферте.
          Агентство обязуется не хранить и не использовать персональные данные Заказчика для рассылки документов и
          сообщений, не имеющих отношения к оформленным Заказам.
        </PublicOfferContent>

        <PublicOfferContent>
          5.3. Заказчик вправе получить консультации по телефону по вопросам бронирования, оформления и продажи
          электронных перевозочных документов. Чтобы получить данные консультации необходимо обратиться в службу
          поддержки по телефону Агентства{" "}
          <a href="tel:+79856344104">+7 (985) 634-41-04</a>.
        </PublicOfferContent>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>6. Ответственность сторон</PublicOfferInfoTitle>

        <PublicOfferContent>
          6.1. Стороны несут ответственность за неисполнение и/или ненадлежащее исполнение своих обязательств по
          настоящей публичной оферте в порядке и на условиях, определённых настоящей публичной офертой и действующим
          законодательством РФ.
        </PublicOfferContent>

        <PublicOfferContent>
          6.2. Агентство не несёт ответственности за невозможность оформления Заказчиком электронного перевозочного
          документа по причинам нарушения работы линий связи, неисправность оборудования и т. п.
        </PublicOfferContent>

        <PublicOfferContent>
          6.3. В случае возникновения обстоятельств непреодолимой силы (форс-мажор), включая: эпидемия, пожар,
          извержение вулкана, наводнение, землетрясение, другие стихийные бедствия и катаклизмы, техногенные
          катастрофы, отсутствие электроэнергии и/или сбои работы компьютерной сети, забастовки, гражданские волнения,
          беспорядки, действия государственных и иных органов, любые иные обстоятельства, препятствующие выполнению
          обязательств Агентства по настоящей публичной оферте, Агентство освобождается от ответственности за частичное
          или полное неисполнение своих обязательств.
        </PublicOfferContent>

        <PublicOfferContent>6.4. Агентство не несёт ответственности за возможные нарушения и действия, которые не входят в сферу его компетенции, а именно:</PublicOfferContent>

        <PublicOfferContentLink>
          <PublicOfferContentLinkComponent>
            за предоставление Заказчиком недостоверных, недостаточных, несвоевременных сведений и документов, нарушение
            Заказчиком условий настоящей публичной оферты или требований к документам;
          </PublicOfferContentLinkComponent>
          <PublicOfferContentLinkComponent>
            за действия органов иммиграционного, таможенного, ветеринарного и фитосанитарного контроля;
          </PublicOfferContentLinkComponent>
          <PublicOfferContentLinkComponent>
            за действия (бездействия) пассажиров, а именно: нарушение пассажиром таможенных и пограничных формальностей,
            правил проезда и провоза багажа, правил поведения в стране временного пребывания; отсутствие у пассажира
            проездных документов, выданных Агентством; неявка или опоздание пассажиров к месту вылета; несоблюдение
            пассажирами правил поведения в самолете; отсутствие у пассажиров надлежащим образом оформленных заграничных
            паспортов, соответствующих документов для вывоза детей;
          </PublicOfferContentLinkComponent>
          <PublicOfferContentLinkComponent>
            за действия перевозчика, связанные с изменением расписания вылетов, отменой или задержкой вылета.
          </PublicOfferContentLinkComponent>
        </PublicOfferContentLink>

        <PublicOfferContent>
          6.5. Заказчик (пассажир) принимает на себя полную ответственность за подготовку всех необходимых для поездки
          документов. Заказчику (пассажиру) следует ознакомиться и исполнять все требования страны, в которую он
          направляется, относительно оформления документов, необходимых при выезде и прибытии, а также при трансферной
          перевозке для следования по всему маршруту, необходимости и условиях оформления виз, действительных паспортов,
          доверенностей или иных документов для выезда детей и др. Агентство не несет ответственности за незнание или
          несоблюдение Заказчиком указанных требований.
        </PublicOfferContent>

        <PublicOfferContent>
          6.6. Споры и разногласия, которые могут возникнуть при исполнении настоящей публичной оферты, стороны будут
          стремиться разрешать путём переговоров, в том числе с соблюдением претензионного порядка. В случае
          невозможности разрешения спора путём переговоров, в том числе в претензионном порядке, спор подлежит
          рассмотрению соответствующим судом по месту нахождения ответчика.
        </PublicOfferContent>

        <PublicOfferContent>6.7. Заказчик подтверждает и гарантирует, что он ознакомлен и согласен:</PublicOfferContent>

        <PublicOfferContentLink>
          <PublicOfferContentLinkComponent>
            с условиями покупки билета, с условиями возврата билетов, а также дополнительной платы взимаемой Агентом;
          </PublicOfferContentLinkComponent>
          <PublicOfferContentLinkComponent>
            с обязанностью ознакомиться и соблюдать правила об особенностях и правилах таможенного, пограничного,
            фитосанитарного, ветеринарного контроля РФ и иностранных государств;
          </PublicOfferContentLinkComponent>
          <PublicOfferContentLinkComponent>
            с полной ответственностью пассажиров за действительность заграничных паспортов, наличие согласий на выезд
            несовершеннолетних детей и иных документов, необходимых для пересечения границы.
          </PublicOfferContentLinkComponent>
        </PublicOfferContentLink>
      </PublicOfferInfo>

      <PublicOfferInfo>
        <PublicOfferInfoTitle>Реквизиты Агентства</PublicOfferInfoTitle>

        <RequisitesTable>
          <tbody>
            <tr>
              <td>Полное наименование</td>
              <td>Общество с ограниченной ответственностью «С-СЕРВИС»</td>
            </tr>
            <tr>
              <td>Сокращённое наименование</td>
              <td>ООО «С-СЕРВИС»</td>
            </tr>
            <tr>
              <td>ИНН / КПП</td>
              <td>7729696371 / 772901001</td>
            </tr>
            <tr>
              <td>ОГРН</td>
              <td>1117746943434</td>
            </tr>
            <tr>
              <td>Юридический адрес</td>
              <td>119454, г. Москва, ул. Лобачевского, д.82, офис 2</td>
            </tr>
            <tr>
              <td>Фактический адрес</td>
              <td>142046, Московская область, городской округ Домодедово, 40 км трассы А-105, стр.3, офис №88</td>
            </tr>
            <tr>
              <td>Телефон</td>
              <td><a href="tel:+79856344104">+7 (985) 634-41-04</a></td>
            </tr>
            <tr>
              <td>ОКПО</td>
              <td>37246569</td>
            </tr>
            <tr>
              <td>ОКОГУ</td>
              <td>49013</td>
            </tr>
            <tr>
              <td>ОКАТО</td>
              <td>45268581000</td>
            </tr>
            <tr>
              <td>Генеральный директор</td>
              <td>Горюшкина Наталия Евгениевна</td>
            </tr>
          </tbody>
        </RequisitesTable>
      </PublicOfferInfo>
    </Wrapper>
  );
};
